import { render, staticRenderFns } from "./DetalheFatura.vue?vue&type=template&id=71565197&scoped=true"
import script from "./DetalheFatura.vue?vue&type=script&lang=js"
export * from "./DetalheFatura.vue?vue&type=script&lang=js"
import style0 from "./DetalheFatura.vue?vue&type=style&index=0&id=71565197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71565197",
  null
  
)

export default component.exports